// Compatibility adapter for consumers that still expect the historical
// ibkrStream tick interface. The normalized quote store owns transport,
// authentication, reconnection, and reference counting.
import { ibkrQuoteSubscriptionStore } from './marketData/ibkrQuoteSubscriptionStore.js'

const LEGACY_TICK_FIELDS = [
  'last', 'close', 'sessionClose', 'lastRth', 'bid', 'ask', 'open', 'high', 'low', 'volume',
]

function positiveNumber(value) {
  const number = Number(value)
  return Number.isFinite(number) && number > 0 ? number : null
}

function quoteToTicks(quote) {
  const receivedTs = Number(quote?.serviceReceiptTime ?? quote?.serviceReceiptTimeMs) || Date.now()
  const eventTs = Number(quote?.providerEventTime ?? quote?.providerEventTimeMs) || null
  const ticks = []
  for (const field of LEGACY_TICK_FIELDS) {
    const value = positiveNumber(quote?.[field])
    if (value == null) continue
    ticks.push({
      type: 'tick', field, value,
      ts: eventTs || receivedTs,
      receivedTs, eventTs,
      source: quote?.source || 'ibkr-normalized-quote',
      freshness: quote?.freshness || null,
      sequence: Number.isFinite(Number(quote?.sequence)) ? Number(quote.sequence) : null,
    })
  }
  return ticks
}

class IBKRStream {
  async subscribe(symbol, callback, optParams = {}) {
    return ibkrQuoteSubscriptionStore.subscribe({ symbol, ...optParams }, quote => {
      for (const tick of quoteToTicks(quote)) {
        try { callback(tick) } catch { /* isolate consumer failures */ }
      }
    })
  }
}

export const ibkrStream = new IBKRStream()
